//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

// === COMPONENTS ===
import { Spacer              } from 'components/Spacer';
import { ExpressionContext   } from '../../../Context/ExpressionContext';
import { TablesMatchControl  } from './components/TableMatch/TableMatch';
import { HasDocumentControls } from './components/HasDocuments/HasDocuments';

// === UTILS ===
import { getHexAlpha } from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function FunctionControls( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const _function_items = [
    { label: 'Has Document' , value: 'DOCUMENT_EXISTS' },
    { label: 'Tables Match' , value: 'TableMatch'      },
  ]

  const { updateExpression } = useContext( ExpressionContext );

  const [ function_name, setFunctionName ] = useState( props.data?.name );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_function: {
      width: '13rem',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_expand: {
      width  : '3rem',
      height : '3rem',
    },
  }

  const SELECT_FUNCTION = {
    sx       : _styles.select_function,
    labelId  : 'function-label',
    id       : 'function-select',
    options  : _function_items,
    value    : function_name,
    size     : 'small',
    onChange : onChange,
    children : _function_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange( event, value ) {
    //-----------------------------------------------------------------
    setFunctionName( event.target.value );
    updateExpression( props.id , { name: event.target.value } )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <React.Fragment key={props.id}>
        <div style={{display: 'flex'}}>
          <FormControl>
            <InputLabel id="function-label">Function</InputLabel>
            <Select   { ...SELECT_FUNCTION } />
          </FormControl>
          <Spacer />
          <div>
            {displayControls()}
          </div>
        </div>
      </React.Fragment>
    );
  }

  //-----------------------------------------------------------------
  function displayControls() {
    //-----------------------------------------------------------------
    if( function_name === 'DOCUMENT_EXISTS' ) return <HasDocumentControls id={props.id} />;
    if( function_name === 'TableMatch'      ) return <TablesMatchControl  id={props.id} data={props.data} />;
    return null;
  }

  //#endregion

  return display();
}
